import { render, staticRenderFns } from "./Report-Top-Section.vue?vue&type=template&id=37a3b018&scoped=true"
import script from "./Report-Top-Section.vue?vue&type=script&lang=js"
export * from "./Report-Top-Section.vue?vue&type=script&lang=js"
import style0 from "./Report-Top-Section.vue?vue&type=style&index=0&id=37a3b018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3b018",
  null
  
)

export default component.exports